import { Injectable } from '@angular/core'
import { UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ManageSubscriptionGuard  {
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.allowManageSubscription) return true
    return false
  }
}
